import { render, staticRenderFns } from "./purchaseorders.vue?vue&type=template&id=e70798ce&scoped=true&"
import script from "./purchaseorders.vue?vue&type=script&lang=js&"
export * from "./purchaseorders.vue?vue&type=script&lang=js&"
import style0 from "./purchaseorders.vue?vue&type=style&index=0&id=e70798ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70798ce",
  null
  
)

export default component.exports